import { render, staticRenderFns } from "./SinglePaymentsModal.vue?vue&type=template&id=01527203&"
import script from "./SinglePaymentsModal.vue?vue&type=script&lang=js&"
export * from "./SinglePaymentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SinglePaymentsModal.vue"
export default component.exports